import { render, staticRenderFns } from "./publicLayout.vue?vue&type=template&id=627ebb38&scoped=true&"
import script from "./publicLayout.vue?vue&type=script&lang=js&"
export * from "./publicLayout.vue?vue&type=script&lang=js&"
import style0 from "./publicLayout.vue?vue&type=style&index=0&id=627ebb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ebb38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContent})
